export class MortalityModel{
  mortalitypatientcode = '' ;
  mortalitydeath = '0' ;
  mortalidate = '2022-01-01' ;
  mortalityreason = '' ;
  mortalitynotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2023-01-01' ;

}

